import { clsx } from 'clsx'
import css from './Loader.module.scss'

type Props = {
  small?: boolean
  white?: boolean
}

export const Loader = ({ small, white }: Props) => {
  const className = clsx(css.loader, small && css.small, white && css.white)

  return <div className={className}>
    <span></span>
    <span></span>
    <span></span>
    <span></span>
  </div>
}
